import { Undo } from '@project-lary/react-material-symbols';
import { useClearChannelMarkReadMutation } from 'gcs-common/clients/api/entities/channels/channel-api';
import { useGetCurrentUser } from 'gcs-common/clients/api/entities/current-user/current-user-api';
import { ButtonVariant } from 'gcs-common/design-system/ui/button';
import IconButton from 'gcs-common/design-system/ui/icon-button';
import { getMessage } from 'gcs-common/slices/messages/messageSelector';
import { getMessagesForChannel } from 'gcs-common/slices/messages/messagesSelectors';
import { useSelector } from 'react-redux';
import type { components } from '../../../types/openapi';

function MarkReadMessage({ messageId }: { messageId: string }) {
  const clearMarkReadMutation = useClearChannelMarkReadMutation();
  const { data: currentUser } = useGetCurrentUser();

  const message = useSelector(getMessage(messageId)) as components['schemas']['ChatMessageCreatedDTO'] | undefined;
  const channelMessages = useSelector(getMessagesForChannel(message?.channelId)) as
    | components['schemas']['ChatMessageCreatedDTO'][]
    | undefined;
  const lastMessage = channelMessages?.[channelMessages.length - 1];

  if (!message || message.messageType !== 'MARK_READ' || !lastMessage) return null;

  const canUndo = message.id === lastMessage.id && message.authorId === currentUser?.id;

  async function handleClick() {
    await clearMarkReadMutation.mutateAsync({ channelId: message!.channelId });
  }

  return (
    <div className="flex items-center justify-center gap-2 p-2 text-neutral-9 text-xs ">
      <div>{message.text}</div>
      {canUndo && (
        <IconButton
          Icon={Undo}
          variant={ButtonVariant.soft_neutral}
          onClick={handleClick}
          isLoading={clearMarkReadMutation.isPending}
        />
      )}
    </div>
  );
}

export default MarkReadMessage;
